import React from 'react';
import logo from '../../../img/logo1.jpg';

function Logo() {
  return (
    <div>
      <img src={logo} alt='Logo' className='logo' />
    </div>
  );
}

export default Logo;
